/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_UnmuteInputs */

const th_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดเสียง`)
};

const en_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable sound`)
};

const ja_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声を有効にする`)
};

const zh_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消静音`)
};

const es_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar sonido`)
};

const pt_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar som`)
};

const id_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyalakan suara`)
};

const fr_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le son`)
};

const tl_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-unmute`)
};

const vi_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật tiếng`)
};

const ko_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`음소거 해제`)
};

const de_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton einschalten`)
};

const ru_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить звук`)
};

const tr_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi aç`)
};

const it_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riattiva l'audio`)
};

const pl_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyłącz wyciszenie`)
};

const uk_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увімкнути звук`)
};

const hi_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ध्वनि चालू करें`)
};

const ar_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء الكتم`)
};

const ms_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyahsenyap`)
};

const bn_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শব্দ চালু করুন`)
};

const zh_tw2_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消靜音`)
};

const zh_hk2_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消靜音`)
};

const ur_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آواز چالو کریں`)
};

const fa_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روشن کردن صدا`)
};

const sw_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washa sauti`)
};

const nl_video_unmute = /** @type {(inputs: Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geluid aan`)
};

/**
* | output |
* | --- |
* | "Enable sound" |
*
* @param {Video_UnmuteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_unmute = /** @type {((inputs?: Video_UnmuteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_UnmuteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_unmute(inputs)
	if (locale === "ja") return ja_video_unmute(inputs)
	if (locale === "zh") return zh_video_unmute(inputs)
	if (locale === "es") return es_video_unmute(inputs)
	if (locale === "pt") return pt_video_unmute(inputs)
	if (locale === "id") return id_video_unmute(inputs)
	if (locale === "fr") return fr_video_unmute(inputs)
	if (locale === "tl") return tl_video_unmute(inputs)
	if (locale === "vi") return vi_video_unmute(inputs)
	if (locale === "ko") return ko_video_unmute(inputs)
	if (locale === "de") return de_video_unmute(inputs)
	if (locale === "ru") return ru_video_unmute(inputs)
	if (locale === "tr") return tr_video_unmute(inputs)
	if (locale === "it") return it_video_unmute(inputs)
	if (locale === "pl") return pl_video_unmute(inputs)
	if (locale === "uk") return uk_video_unmute(inputs)
	if (locale === "hi") return hi_video_unmute(inputs)
	if (locale === "ar") return ar_video_unmute(inputs)
	if (locale === "ms") return ms_video_unmute(inputs)
	if (locale === "bn") return bn_video_unmute(inputs)
	if (locale === "zh-TW") return zh_tw2_video_unmute(inputs)
	if (locale === "zh-HK") return zh_hk2_video_unmute(inputs)
	if (locale === "ur") return ur_video_unmute(inputs)
	if (locale === "fa") return fa_video_unmute(inputs)
	if (locale === "sw") return sw_video_unmute(inputs)
	if (locale === "nl") return nl_video_unmute(inputs)
	return en_video_unmute(inputs)
});